<template>
    <div class="h5-wrapper">
        <!-- 页面内容区域 - 使用 router-view 显示子页面 -->
        <div class="content">
            <!-- 下面的内容会根据路由切换而变化  配置嵌套路由的出口 (父容器是LayOut 详情请看 router/index.js) -->
            <keep-alive include="[LayOut]">
                <router-view></router-view>
            </keep-alive>
        </div>

        <!-- 底部导航栏 - TabBar -->
        <nav class="navbar fixed-bottom navbar-light bg-light border-top">
            <div class="container-fluid justify-content-around">
                <!-- 手动定义TabBar项目，确保正确显示 -->
                <router-link to="/article" class="nav-link text-center" active-class="text-primary fw-bold" exact>
                    <i class="bi bi-journal-text d-block fs-4"></i>
                    <small>面经</small>
                </router-link>

                <router-link to="/collection" class="nav-link text-center" active-class="text-primary fw-bold" exact>
                    <i class="bi bi-bookmark-heart d-block fs-4"></i>
                    <small>收藏</small>
                </router-link>

                <router-link to="/like" class="nav-link text-center" active-class="text-primary fw-bold" exact>
                    <i class="bi bi-heart-fill d-block fs-4"></i>
                    <small>喜欢</small>
                </router-link>

                <router-link to="/user" class="nav-link text-center" active-class="text-primary fw-bold" exact>
                    <i class="bi bi-person-circle d-block fs-4"></i>
                    <small>我的</small>
                </router-link>
                <router-link to="/color" class="nav-link text-center" active-class="text-primary fw-bold" exact>
                    <i class="bi bi-palette d-block fs-4"></i>
                    <small>颜色</small>
                </router-link>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    name: 'LayOut'
}
</script>

<style scoped>
/* 页面容器样式 - 确保内容不被底部导航栏遮挡 */
.h5-wrapper {
    padding-bottom: 70px;
    background-color: #f8f9fa;
}

/* 内容区域样式 */
.content {
    min-height: calc(100vh - 70px);
    padding: 15px;
    overflow-y: auto;
}

/* 底部导航栏样式优化 */
.navbar {
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    background-color: #ffffff !important;
}

/* 导航链接样式 - 移动端优化 */
.nav-link {
    color: #6c757d;
    text-decoration: none;
    padding: 8px 0;
    transition: all 0.3s ease;
    /* 移动端触摸优化 */
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
    user-select: none;
    min-width: 60px;
    min-height: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

/* 悬停效果 */
.nav-link:hover {
    color: #0d6efd !important;
    transform: translateY(-2px);
}

/* 激活状态样式 */
.text-primary {
    color: #0d6efd !important;
}

/* 确保图标和文字间距合适 */
.nav-link i {
    margin-bottom: 2px;
}

.nav-link small {
    font-size: 12px;
    font-weight: 500;
}

/* 响应式调整 */
@media (max-width: 576px) {
    .nav-link {
        font-size: 12px;
        padding: 6px 0;
    }

    .fs-4 {
        font-size: 1.2rem !important;
    }

    .content {
        padding: 10px;
    }
}
</style>